// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__zsa1Q","footer":"ModalFilter_footer__3qSku"};